import { Space } from 'antd';
import { useContext } from 'react';

import { VISITS_FILTER } from '@app/constants';
import { ClientFiltersContext } from '@app/providers';

import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const VisitsEmployeesLabel = ({
  filterGroupIndex,
}: {
  filterGroupIndex: number;
}) => {
  const { filters, serverFilters, setFilters, setServerFilters } =
    useContext(ClientFiltersContext);

  return (
    <Space
      className={`visits-employees-label${filterGroupIndex}`}
      direction="vertical"
    >
      <span>Исполнитель</span>
      <ClientFilterTag
        filters={filters}
        serverFilters={serverFilters}
        filtersArea={VISITS_FILTER}
        filterGroupIndex={filterGroupIndex}
        setFilters={setFilters}
        setServerFilters={setServerFilters}
        valueKey={
          'EmployeeIds' as keyof NClientsList.VisitsFilterUnitValue['EmployeeIds']
        }
      >
        {`Выбрано: ${
          serverFilters?.VisitsFilter?.[filterGroupIndex]?.Values?.[0]
            ?.EmployeeIds?.length || 0
        }`}
      </ClientFilterTag>
    </Space>
  );
};
